const getPublishingStatus = (state: AnyFixMe) => state.publishingStatus;

export { getPublishingStatus };
